module.exports = __webpack_public_path__ + "static/media/evt.ba266a69.PNG";